import React from "react";
import {
    BASE_10,
} from "../constants";
import ICustomer from "../interfaces/ICustomer";
import ITicket from "../interfaces/ITicket";
import formatDate from "../utils/formatDate";
import formatOgsDollar from "../utils/formatOgsDollar";
import API from "../utils/OGSAPI";
import NotFoundPage from "./NotFoundPage";

interface IProps {
    customer?: ICustomer;
}

interface IState {
    fetchingTickets: boolean;
    tickets: ITicket[];
}

export default class TicketsPage extends React.PureComponent<IProps, IState> {
    public state: IState = {
        fetchingTickets: false,
        tickets: [],
    };
    public componentDidMount(): void {
        this.componentWillReceiveProps({});
    }
    public componentWillReceiveProps(nextProps: IProps): void {
        if (this.props.customer === nextProps.customer) {
            return;
        }

        this.setState({
            fetchingTickets: true,
            tickets: [],
        });

        API.fetchTickets().then((tickets: ITicket[]): void => {
            tickets.sort((a: ITicket, b: ITicket): number => {
                return parseInt(b.id, BASE_10) - parseInt(a.id, BASE_10);
            });
            this.setState({
                fetchingTickets: false,
                tickets,
            });
        });
    }
    public render(): JSX.Element {
        const { fetchingTickets, tickets } = this.state;
        const { customer } = this.props;

        if (!customer) {
            return (
                <NotFoundPage />
            );
        }

        if (fetchingTickets) {
            return (
                <div className="content-wrapper">
                    Loading..
                </div>
            );
        }

        if (!tickets.length) {
            return (
                <div className="content-wrapper">
                    There are no tickets to display.
                </div>
            );
        }

        return (
            <div className="content-wrapper">
                <div>Tickets</div>
                <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Date</th>
                            <th>Event</th>
                            <th>Ticket Cost</th>
                            <th>Amount Won</th>
                        </tr>
                    </thead>
                    <tbody>
                        { tickets.map((ticket: ITicket): JSX.Element => {
                            return (
                                <tr key={ ticket.id }>
                                    <td>{ ticket.id }</td>
                                    <td>{ formatDate(ticket.createdTimestamp) }</td>
                                    <td>{ ticket.event ? ticket.event.description : "-" }</td>
                                    <td>{ formatOgsDollar(ticket.cost, { symbolPrefix: "$" }) }</td>
                                    <td>{ formatOgsDollar(ticket.amountWon, { symbolPrefix: "$" }) }</td>
                                </tr>
                            );
                        }) }
                    </tbody>
                </table>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/TicketsPage.tsx